<template>
  <div class="center-loading">
    <mu-circular-progress :size="36" />
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "LogoutPage",
  methods: {
    ...mapActions("user", ["logout"])
  },
  created() {
    this.logout();
  }
};
</script>
